// A phone confirmation is treated as proof of an order. Only rows the
// kitchen actually accepted may be drawn as a ticket or a receipt.
// Card checkout creates the row before Tyro captures payment, so
// `awaiting_payment` is not an order yet. Clearing a stuck attempt
// cancels it but leaves payment_method as `card` / `paypal`.

function neverCaptured(order) {
  if (!order) return true;
  if (order.status === 'awaiting_payment') return true;
  if (order.status === 'cancelled' && (order.payment_method === 'card' || order.payment_method === 'paypal')) {
    return true;
  }
  return false;
}

function acceptedOrders(orders) {
  return (orders || []).filter((order) => !neverCaptured(order));
}

module.exports = { neverCaptured, acceptedOrders };
